import Axios from 'axios';
import _ from 'lodash';

const EMAIL_HEADER = 'X-User-Email';
const TOKEN_HEADER = 'X-User-Token';

export function getCreds() {
  return {
    email: localStorage[EMAIL_HEADER],
    token: localStorage[TOKEN_HEADER]
  }
}

export function isMissingCreds() {
  const { email, token } = getCreds();
  return _.isEmpty(email) || _.isEmpty(token);
}

export function storeCreds(email, token) {
  localStorage[EMAIL_HEADER] = email;
  localStorage[TOKEN_HEADER] = token;
}

export function installAuthInterceptor(credsGetter = getCreds) {
  Axios.interceptors.request.use(function (config) {
    const creds = credsGetter();
    if (_.isUndefined(creds.email)) {
      return config;
    }
    const authHeaders = {
      [EMAIL_HEADER]: creds.email,
      [TOKEN_HEADER]: creds.token
    };
    const commonHeaders = {...config.headers.common, ...authHeaders};
    const headers = {...config.headers, common: commonHeaders};
    return {...config, headers};
  });
}



// WEBPACK FOOTER //
// ./src/modules/auth/auth-utils.js